import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Stack, Grid, Slider } from '@mui/material';
import { ChromePicker, ColorResult } from 'react-color';

function generateSVGPattern(color1: string, color2: string, size: number) {
  // Daireli (polka dot) SVG pattern
  const dotRadius = size / 8;
  const spacing = size / 2;
  return `
<svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
  <rect width="${size}" height="${size}" fill="${color1}"/>
  <circle cx="${dotRadius + spacing * 0}" cy="${dotRadius + spacing * 0}" r="${dotRadius}" fill="${color2}" />
  <circle cx="${dotRadius + spacing * 1}" cy="${dotRadius + spacing * 0}" r="${dotRadius}" fill="${color2}" />
  <circle cx="${dotRadius + spacing * 0}" cy="${dotRadius + spacing * 1}" r="${dotRadius}" fill="${color2}" />
  <circle cx="${dotRadius + spacing * 1}" cy="${dotRadius + spacing * 1}" r="${dotRadius}" fill="${color2}" />
</svg>
`;
}

const ColorPatternGenerator: React.FC = () => {
  const [color1, setColor1] = useState('#2196f3');
  const [color2, setColor2] = useState('#f50057');
  const [size, setSize] = useState(120);
  const [svg, setSvg] = useState(generateSVGPattern('#2196f3', '#f50057', 120));

  const handleColor1Change = (c: ColorResult) => {
    setColor1(c.hex);
    setSvg(generateSVGPattern(c.hex, color2, size));
  };
  const handleColor2Change = (c: ColorResult) => {
    setColor2(c.hex);
    setSvg(generateSVGPattern(color1, c.hex, size));
  };
  const handleSizeChange = (_: any, val: number | number[]) => {
    setSize(val as number);
    setSvg(generateSVGPattern(color1, color2, val as number));
  };

  const handleDownloadSVG = () => {
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'pattern.svg';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', my: 4 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>Renkte Görsel Üretici</Typography>
        <Typography sx={{ mb: 2 }}>Seçtiğiniz renklerle otomatik SVG desen oluşturun ve indirin.</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={700} mb={1}>Renk 1</Typography>
            <ChromePicker color={color1} onChange={handleColor1Change} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={700} mb={1}>Renk 2</Typography>
            <ChromePicker color={color2} onChange={handleColor2Change} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={700} mb={1}>Desen Boyutu</Typography>
            <Slider min={60} max={400} value={size} onChange={handleSizeChange} valueLabelDisplay="auto" />
            <Typography>Boyut: {size}px</Typography>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" mb={2}>SVG Desen Önizleme</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
          <div dangerouslySetInnerHTML={{ __html: svg }} />
        </Box>
        <Button variant="contained" color="primary" onClick={handleDownloadSVG}>SVG Olarak İndir</Button>
      </Paper>
    </Box>
  );
};

export default ColorPatternGenerator; 